"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const pageParts_1 = require("../pageParts");
const react_redux_1 = require("react-redux");
const PrivateRoute = (_a) => {
    var { permissions, component: Component } = _a, rest = __rest(_a, ["permissions", "component"]);
    const user = (0, react_redux_1.useSelector)((state) => state.auth.user);
    const isAuthenticated = (0, react_redux_1.useSelector)((state) => !!state.auth.isAuthenticated);
    const location = (0, react_router_1.useLocation)();
    // Remember the requested URL so redirectAfterLogin (which reads
    // location.state.referrer) can send the user back here after they log in,
    // instead of always falling back to the home page (see issue #1946).
    const referrer = `${location.pathname}${location.search}${location.hash}`;
    return isAuthenticated && user ? (permissions ? (user.isAuthorized(permissions) ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pageParts_1.Header, { path: rest.path, appName: project_config_1.default === null || project_config_1.default === void 0 ? void 0 : project_config_1.default.appName }),
        react_1.default.createElement(Component, Object.assign({}, rest.componentProps)))) : (react_1.default.createElement(react_router_1.Navigate, { to: "/unauthorized" }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pageParts_1.Header, { path: rest.path, appName: project_config_1.default === null || project_config_1.default === void 0 ? void 0 : project_config_1.default.appName }),
        react_1.default.createElement(Component, Object.assign({}, rest.componentProps))))) : (react_1.default.createElement(react_router_1.Navigate, { to: "/login", state: { referrer }, replace: true }));
};
exports.default = PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map